import React, { useEffect, useState } from 'react'
import Cards from '../Dashboard/Card';
import CommonPagination from '../../../utils/Pagination';
import SearchBar from '../../../utils/searchbar';
import GlobalButton from '../../../utils/GlobalButton';
import dashboard from '../../../css/dashboard.module.css'
import SortMenu from '../Analytics/SortMenu';
import Alerts from '../../shared/Alerts';
import { channelName } from '../../shared/AlertMessages';
import { deleteChannel, fetchChannels } from '../../shared/ApiEndpoint';
import { LIMIT } from '../../shared/Constant';
import axiosInstance from '../../../utils/axiosInstance';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { updateURLFilters } from '../../../utils/updateURLFilters';

const ChannelDetails = () => {
  const navigate = useNavigate();
  const [searchParam,setSearchParam]=useSearchParams();
  const initialParam=searchParam.get('keyword')||'';
  const initialPage = searchParam.get('page') || 1;
  const initial_SortBy = searchParam.get('sort_by') || "sort_by";
  const [newSelectedSort,setnewSelectedSort]=useState(initial_SortBy);
  const [currentPage, setCurrentPage] = useState(initialPage);
   const [showConfirmModal,setShowConfirmModal]=useState(false);
   const [searchTerm,setSearchTerm]=useState(initialParam);
   const [totalCount,setTotalCount]=useState(0);
   const [ChannelDetails,setChannelDetails]=useState([
  {
    channel_id: 0,
    channel_name: "",
    channel_desc: "",
    createddate: "",
    modifieddate: ""
  }])
const sortOptions = [
  { label: "Name (A-Z)", value: 1 ,urladd:"name_asc"},
  { label: "Name (Z-A)", value: 2,urladd:"name_desc" },
  { label: "DateAsc", value:3,urladd:"date_asc"},
  { label: "DateDesc", value: 4,urladd:"date_desc"},
];
      // const [show,setShow]=useState(false);
        const [id,SetselectedId]=useState(null);

useEffect(()=>{
  fetch_channels(searchTerm,currentPage,newSelectedSort);
// eslint-disable-next-line react-hooks/exhaustive-deps
},[])


      const fetch_channels=async(searchTerm="",currentPage=1,sort_by="sort_by")=>{
        try {
          const response = await axiosInstance.post(fetchChannels,{
            limit:LIMIT,
            page_number:currentPage,
            ...(searchTerm && {search:searchTerm }),
           ...(typeof sort_by === "number" && { sort_by: sort_by })
          }, {withCredentials: true});
          if (response?.status === 200) {
            const data=response?.data?.result;
            const count = response?.data?.total;
            const channels=data.map((channel,index)=>({
              channel_id:channel?.channel_id,
              channel_name:channel?.channel_name,
              channel_desc:channel?.channel_desc,
              createddate:channel?.createddate,
              modifieddate:channel?.modifieddate
            }))
            setChannelDetails(channels);
            setTotalCount(count);
          }
        } catch (error) {
          console.error("Failed to fetch channels", error);
        }
      }
       const handleDelete=(id)=>{
        setShowConfirmModal(true);
        SetselectedId(id);
      }

      const handleDeleteChannel = async (channel_id) => {
        const resp = await axiosInstance.put(`${deleteChannel}/${channel_id}`, {
         
        }, { withCredentials: true });
        if (resp?.status === 200) {
          fetch_channels(searchTerm,currentPage,newSelectedSort);
        }
      }
        const handleOnSearch = (string, results) => {
    setSearchTerm(string);
  };

      const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        event.preventDefault();
        if (searchTerm.trim() !== "") {
          fetch_channels(searchTerm,currentPage,newSelectedSort);
        }
        if (searchTerm.trim() === "") {
          // setApprovedDeals([]);
          // setPendingDeals([]);
          // setCurrentPage(1);
          fetch_channels(searchTerm,currentPage,newSelectedSort);
        }
        updateURLFilters( searchParam, setSearchParam, { keyword: searchTerm })
      }
    };
    const onSortChange = (value) => {
      const sort=value?.value
       fetch_channels(searchTerm,currentPage,sort);
       updateURLFilters( searchParam, setSearchParam, { sort_by: sort })
      setnewSelectedSort(sort);
    };
        const handlePageChange = (page) => {
    setCurrentPage(page);
     fetch_channels(searchTerm,page,newSelectedSort);
    updateURLFilters(searchParam, setSearchParam, { page: page ? page : null });
    // Fetch new data or update content here
  };

  return (
<>
<div>
    <div className="row align-items-center justify-content-between">
  <div className="col-md-6" onKeyDown={handleKeyDown}>
    <SearchBar placeholder="Search your bots by name ..." searchTerm={searchTerm} handleOnSearch={handleOnSearch} />
  </div>

  <div className="col-lg-6 col-md-6 d-flex justify-content-end gap-3 mt-2 mt-md-0">
    <SortMenu onSortChange={onSortChange} sortOptions={sortOptions} selectedSort={newSelectedSort}
              setSelectedSort={setnewSelectedSort} />
     <GlobalButton children="Create New Channel"  size="md" className={`${dashboard.backgroundColor} ${dashboard.nohover}`  } onClick={() => navigate('/channeldetails/input')}
  variant="contained"
  // onClick={() => setShow(true)}
/>

  </div>
</div>
<div className="row g-3 mt-2">
 
   {ChannelDetails.map((item,index)=>(
     <div className="col-md-4 col-sm-6 col-lg-3 " key={index}>
    <Cards id={item.channel_id} name={item.channel_name} title={item.channel_desc} createdDate={item.createddate} modifiedDate={item.modifieddate} navigateeditIcon={`/channeldetails/input?id=${item.channel_id}`} handleDelete={handleDelete}/>
     </div>
   ))}

   {showConfirmModal && <Alerts  antTitle={channelName.text} antContent={channelName.content} antOkText={channelName.confirm} antCancelText={channelName.cancel}  setShowConfirmModal={setShowConfirmModal} confirmMsgText={channelName.confirmtext} id={id} action={handleDeleteChannel}/>}

</div>
</div>
{/* <CreateBotModal show={show} handleClose={() => setShow(false)}/> */}
{totalCount> LIMIT &&   <CommonPagination total={totalCount} pageSize={LIMIT} currentPage={currentPage} showSizeChanger={false} onPageChange={handlePageChange}/>}
</>
  )
}

export default ChannelDetails
